import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const venue = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name of the venue.'),

    address: z
      .string()
      .nullable()
      .optional()
      .describe('Street address of the venue.'),

    positions: hasMany('Position', 'venueId'),

    trainingClasses: hasMany('TrainingClass', 'venueId'),
  })
  .describe(
    'A physical location where events are held or training takes place.',
  )
  .as('Venue');

export { venue as venueSchema };
